let terms = null;

export function loadTerms(givenTerms) {
  terms = givenTerms;
}

export function getText(type, field) {
  return terms && (terms[type][field] || "");
}
